export const creatureSizes = [
  {
    description: "Rodent to housecat",
    damage: -2,
  },
  {
    description: "Large dog to wildcat",
    damage: -1,
  },
  {
    description: "Humanoid in size",
    damage: 0,
  },
  {
    description: "Larger than human, like a huge gorilla",
    damage: 1,
  },
  {
    description: "Cow to alligator",
    damage: 2,
  },
];
